<template>
  <div class="comment_container">
    <div class="comment_list">
    <div v-for="(item, index) in comments" @click="disabledComment('update_cm', item.id)" :key="index"
      class="comment_item">
      <div style="margin-bottom: 0;">
        <div class="avatar">{{ item.createTime + ' '}} {{item.creator.nameZh ? item.creator.nameZh: ''}}{{item.creator.nameEn ? '('+item.creator.nameEn+')': ''}}添加了评论：
        </div>
        <div class="comment_box" v-html="item.comment">
        </div>
        <span   v-if="item.canOperate"  style="color:rgb(234 176 89);margin: 0 20px;cursor: pointer;"
          @click.stop="onCommentSubmit('delete_cm', item.id)">删除</span>
<!--        <el-button v-if="item.creator_id === username && item.disabled" size="mini" type="warning"
          @click="onCommentSubmit('update_cm', item.id)">修 改</el-button>-->
      </div>
<!--      <EditorComment :cid="String(item.id)" :config="allSelect" :content="item.comment"
        @commentData="changeCreateCmContent" :disabled="item.disabled && item.creator_id === username" />-->
    </div>
    </div>
      <div class="comment_new" style="margin-top:20px;"  @click="disabledComment('create_cm')">
      <EditorComment :config="allSelect" :content="create_cm" @commentData="changeCreateCmContent" />
      <div style="margin-top:10px;" v-show="show_create_cm">
        <el-button type="primary" size="mini" @click="onCommentSubmit('create_cm')">添 加</el-button>
        <el-button size="mini" @click="onCommentCancel('create_cm')">取 消</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getDevOpsSpaceFindProjectCommentApi,
  getDevOpsSpaceProducerCommentApi,
  postDevOpsSpaceCreateProjectInsertCommentApi,
  postDevOpsSpaceDeleteProjectCommentApi, postDevOpsSpaceDeleteTaskApi,
  postDevOpsSpaceProducerCreateCommentApi,
  postDevOpsSpaceProducerDeleteCommentApi,
  postDevOpsSpaceProducerUpdateCommentApi,
  postDevOpsSpaceUpdateProjectCommentApi
} from "@/server/tops/devOps";
import { EditorComment } from "@/components/index.js";
import { mapState } from "vuex";
export default {
  components: { EditorComment },
  props: {
    busiId: {
      type: [String, Number],
      default: function () {
        return ''
      }
    },
    type: {
      default: function () {
        return ''
      }
    }
  },
  data() {
    return {
      comments: [],
      create_cm: "",
      show_create_cm: false,
      username: '',
    };
  },
  async created() {
    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    this.username = username;
    await this.queryCommentInfo()
  },
  computed: {
    ...mapState(
      {
        allSelect: (state) => state.devOps.ALLSELECT,
      }
    )
  },
  methods: {
    // 获取评论信息
    async queryCommentInfo() {


      const ret = await getDevOpsSpaceFindProjectCommentApi({ busiId: this.busiId, type: this.type })
      this.comments = ret.data.map((item) => {
        item.disabled = false;
        return item;
      });
      console.log(this.comments)
    },
    // 写入评论信息
    changeCreateCmContent({ text, cid, show }) {
      if (!cid) {
        this['create_cm'] = text;
        this.show_create_cm = show;
      } else {
        this.comments = this.comments.map(item => {
          if (item.id == cid) {
            item.comment = text;
          }
          return item;
        })
      }
    },
    // 提交评论信息
    async onCommentSubmit(stype, cid) {
      const { busiId = '', type = '', username } = this;
      if (stype === 'create_cm') {
        await postDevOpsSpaceCreateProjectInsertCommentApi({ busiId,  comment: this[stype], type:Number(type)})
        await this.queryCommentInfo()
        this[stype] = '';
        setTimeout(() => {
          this['show_' + stype] = false;
        })
        return;
      }
      if (stype === 'delete_cm') {
        this.$confirm("此操作将删除该评论, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          await postDevOpsSpaceDeleteProjectCommentApi({ id: cid })
          await this.queryCommentInfo()
          return;
        });
      }
      if (stype === 'update_cm') {
        const item = this.comments.filter(item => item.id === cid)
        await postDevOpsSpaceUpdateProjectCommentApi({ id:cid, busiId, comment: item[0].comment, type:Number(type), creator_user:username })
        await this.queryCommentInfo()
        return;
      }
    },
    // 取消评论信息
    onCommentCancel(type) {
      this[type] = '';
      setTimeout(() => {
        this['show_' + type] = false;
      })
    },
    disabledComment(type, cid) {
      this.comments = this.comments.map((item) => {
        item.disabled = item.id === cid;
        return item;
      });
      this.show_create_cm = (type === 'create_cm');
    },
  },
};
</script>
<style lang="scss" scoped>
.comment_container {
  .avatar {
   /* height: 20px;
    line-height: 20px;*/
    text-align: left;
    border-radius: 4px;
    overflow: hidden;
  }
}
</style>
<style lang="scss">
.comment_new {
  .editorComment_warp {
    .editorComment {
      .ql-editor {
        min-height: 60px !important;
      }
    }
  }
}

.devOps-producerModel {
  .comment_warp {
    .comment_item>div {
      display: flex;
      margin: 0;
      margin-bottom: 12px;

      .el-textarea__inner {
        font-weight: bold;
      }
    }

  }

  .el-button--mini {
    padding: 6px 10px;
    font-size: 12px;
  }

  .el-form-item__content .el-button {
    position: relative;
    letter-spacing: 2px !important;
  }

  .el-form-item__label {
    font-weight: bold;
  }

  .el-button {
    font-weight: bold;
  }

  .share {
    position: absolute;
    top: 20px;
    right: 46px;
    cursor: pointer;
    color: #409eff;
  }
}
.comment_list {
  max-height: 100px;
  overflow-y: auto;
  white-space: pre-wrap;
  /* background: #f1fbec; */
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
  line-height: 20px;
}
.comment_list::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 16px;
}

.comment_list::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.comment_list::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}
.comment_box{
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  /*line-height: 10px;*/
}
.comment_box p{
  margin-bottom: 0;
  margin-top: 0;
}
</style>